import { Object, String, Static } from '@sinclair/typebox';

export type TokensApiHeaders = Static<typeof TokensApiHeaders>;
export const TokensApiHeaders = Object({
  'secret-key': String(),
});
